// Libraries
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Grid from '@mui/material/Grid';

// Core
import { ResourceTextApplication } from '../../../core/resources';

// Common
import { ASwitch } from '../../../common/inputs';

// Interfaces
// Store
// API
// Feature

interface ICreatePreliminaryAnnouncementsForGroupSwitchProps {
    handleCreatePreliminaryAnnouncementsValueChange: (value: boolean) => void;
}

export default function CreatePreliminaryAnnouncementsForGroupSwitch({
    handleCreatePreliminaryAnnouncementsValueChange,
}: ICreatePreliminaryAnnouncementsForGroupSwitchProps) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaBovine']);
    const preliminaryAnnouncementsForGroupsSwitch =
        'anelma-preliminary-announcement-switch-for-groups';

    const [loading, setLoading] = useState<boolean>(false);
    const [createPreliminaryAnnouncements, setCreatePreliminaryAnnouncements] =
        useState<boolean>(false);

    const handlePreliminaryAnnouncementSwitchChange = (value: boolean) => {
        setCreatePreliminaryAnnouncements(value);
        handleCreatePreliminaryAnnouncementsValueChange(value);
    };

    return (
        <Grid
            sx={{
                marginBottom: '2em',
                marginRight: '6em',
                justifyContent: 'flex-end',
                display: 'flex',
            }}
        >
            <Grid size={{ md: 12 }}>
                <ASwitch
                    id={preliminaryAnnouncementsForGroupsSwitch}
                    data-robot-id={preliminaryAnnouncementsForGroupsSwitch}
                    label={t('AnelmaBovine:1185')}
                    checked={createPreliminaryAnnouncements}
                    onChange={handlePreliminaryAnnouncementSwitchChange}
                    disabled={loading}
                    withoutContainer
                />
            </Grid>
        </Grid>
    );
}
